// 散点图PLS-DA
import ChartTemplate from '../ChartTemplate';
import { userFileRead } from '@/plugins/api';
import $ from '@/assets/jquery/jquery-vendor.js';
import { SVG } from '@svgdotjs/svg.js';
import '@svgdotjs/svg.draggable.js';

let ellipseData, xm = 0, ym = 0, scale = 1.1; // 绘制椭圆所需数据,x刻度线最大值,y刻度线最大值, 扩大倍数
export default {
  extends: ChartTemplate,
  props: {
    formButtons: {
      default: function () {
        return [{ embed: true, code: 'ss', name: '标记', text: true, click: () => this.onShowSs() }]
      }
    },
    config: {
      default: function () { return { group: 1, name: 0, z: -1, ellipseFile: 'plsda_Ellipse.xlsx' } }
    }
  },
  data () {
    return {
      ss: [],
      extCPT: () => import('./ExtendComponent.vue'),
      extCPTValue: false
    }
  },
  computed: {
    extCPTProps () { return { items: this.ss } }
  },
  methods: {

    async initDataAfter () {
      let dto = this.Utility.clone(this.dataSourceParam);
      if (this.embed) {
        let p1 = dto.path;
        let p2 = p1.substring(0, p1.lastIndexOf('/')) + '/' + this.config.ellipseFile;
        dto.path = p2;
      } else {
        dto.toolTask.resultFile = this.config.ellipseFile;
      }
      await userFileRead(dto).then(res => {
        ellipseData = res.data;
        if (ellipseData && ellipseData.length) {
          ellipseData.slice(1).forEach(d => {
            if (xm < d[0]) xm = d[0];
            if (ym < d[1]) ym = d[1];
          })
          xm = parseInt(xm * scale);
          ym = parseInt(ym * scale);
        }
      })
    },
    initChartAfter () {
      if (ellipseData && ellipseData.length) {
        this.drawEllipse();
      }
      this.drawBorder();
    },
    initOptionAfter () {
      let option = {
        legend: { enabled: true },
        plotOptions: { series: { stickyTracking: false, dataLabels: { allowOverlap: true, format: '{point.name}' }, point: { events: { click: this.pointClick } } } },
        xAxis: { plotLines: [{ value: 0, color: '#000000', width: 1, zIndex: 3 }] },
        yAxis: { title: { text: null }, gridLineWidth: 0, tickWidth: 1, plotLines: [{ value: 0, color: '#000000', width: 1, zIndex: 3 }] }
      }
      if (xm) {
        option.xAxis.min = -xm;
        option.xAxis.max = xm;
      }
      if (ym) {
        option.yAxis.min = -ym;
        option.yAxis.max = ym;
      }
      this.Utility.deepMerge(this.chartOption, option);
    },
    onParamFormChangedAfter (value, item) {
      let ele = document.getElementById(`${this.chartElId}_trust_ellipse`);
      ele.remove();
      this.drawEllipse();
      if (item.code == 'SampleLabel') {
        let ls = $('.highcharts-data-labels');
        if (ls.length) for (let i = 0; i < ls.length; i++) ls[i].onmouseover = null;
      }
    },

    // ============================ 点标记
    pointClick (e) {
      let point = e.point;
      if (this.ss.indexOf(point) == -1) {
        let dataLabels = { enabled: true, allowOverlap: true, format: '{point.name}', shape: 'callout', borderWidth: 1, borderColor: '#1976D2', x: 50 };
        point.update({ dataLabels: dataLabels });
        this.ss.push(point);
        this.initDataLabelListener(point);
      } else {
        this.ss.splice(this.ss.indexOf(point), 1);
        point.update({ dataLabels: { enabled: false } });
      }
    },
    initDataLabelListener (point) {
      let $g = SVG(point.dataLabel.element); // {g:[path,{text:[tspan,tspan]}]}
      let $text = $g.children()[1];
      $text.plain($text.children()[0].text());
      let $path = $g.children()[0];
      let _bps = $path.array().filter(a => a[0] != 'C');
      let w = Math.abs(_bps[1][1] - _bps[0][1]), h = Math.abs(_bps[2][2] - _bps[1][2]), cx, cy;
      if (_bps.length > 6) cx = _bps[5][1], cy = _bps[5][2];
      else {
        let $point = SVG(point.graphic.element);
        let pcx = $point.cx(), pcy = $point.cy();
        let gTrans = $g.transform();
        cx = Math.abs(pcx - gTrans.translateX), cy = Math.abs(pcy - gTrans.translateY);
      }
      let x1, y1, x, y, textX, textY;
      $text.draggable().on('beforedrag', e => {
        x1 = e.detail.event.x; y1 = e.detail.event.y;
        let ds = $path.array()[0];
        x = ds[1]; y = ds[2];
        textX = e.target.instance.x(); textY = e.target.instance.y();
      }).on('dragmove', e => {
        let x2 = e.detail.event.x, y2 = e.detail.event.y;
        let ex = x2 - x1, ey = y2 - y1;
        let nx = x + ex, ny = y + ey;
        let p1 = { x: nx, y: ny }, p2 = { x: nx + w, y: ny }, p3 = { x: nx + w, y: ny + h }, p4 = { x: nx, y: ny + h };
        let cp1 = { x: p1.x + (p2.x - p1.x) / 2, y: p1.y }, cp2 = { x: p2.x, y: p2.y + (p3.y - p2.y) / 2 }, cp3 = { x: p4.x + (p3.x - p4.x) / 2, y: p3.y }, cp4 = { x: p1.x, y: p1.y + (p4.y - p1.y) / 2 };
        let cpp = { x: cx, y: cy };
        let dis1 = this.getDistance(cpp, cp1), dis2 = this.getDistance(cpp, cp2), dis3 = this.getDistance(cpp, cp3), dis4 = this.getDistance(cpp, cp4);
        let minDis = Math.min(dis1, dis2, dis3, dis4);
        let d;
        if (minDis == dis1) { // 连接矩形的上边
          d = `M ${p1.x} ${p1.y} L ${p1.x + (p2.x - p1.x) / 2} ${p1.y} L ${cx} ${cy} L ${p1.x + (p2.x - p1.x) / 2} ${p1.y} L ${p2.x} ${p2.y} L ${p3.x} ${p3.y} L ${p4.x} ${p4.y} L ${p1.x} ${p1.y}`;
        } else if (minDis == dis2) {  // 连接矩形的右边
          d = `M ${p1.x} ${p1.y} L ${p2.x} ${p2.y} L ${p2.x} ${p2.y + (p3.y - p2.y) / 2} L ${cx} ${cy} L ${p2.x} ${p2.y + (p3.y - p2.y) / 2} L ${p3.x} ${p3.y} L ${p4.x} ${p4.y} L ${p1.x} ${p1.y}`;
        } else if (minDis == dis3) {  // 连接矩形的下边
          d = `M ${p1.x} ${p1.y} L ${p2.x} ${p2.y} L ${p3.x} ${p3.y} L ${p4.x + (p3.x - p4.x) / 2} ${p3.y}  L ${cx} ${cy} L ${p4.x + (p3.x - p4.x) / 2} ${p3.y} L ${p4.x} ${p4.y} L ${p1.x} ${p1.y}`;
        } else if (minDis == dis4) { // 连接矩形的左边
          d = `M ${p1.x} ${p1.y} L ${p2.x} ${p2.y} L ${p3.x} ${p3.y} L ${p4.x} ${p4.y} L ${p1.x} ${p1.y + (p4.y - p1.y) / 2} L ${cx} ${cy} L ${p1.x} ${p1.y + (p4.y - p1.y) / 2} L ${p1.x} ${p1.y}`;
        }
        $path.plot(d);
        e.target.instance.x(textX + ex).y(textY + ey);
      })
    },
    getDistance (p1, p2) {
      let xs = p2.x - p1.x;
      xs = xs * xs;
      let ys = p2.y - p1.y;
      ys = ys * ys;
      return Math.sqrt(xs + ys);
    },
    onShowSs () {
      this.extCPTValue = true;
    },
    onDeleteSs (index) {
      let point = this.ss[index];
      this.ss.splice(index, 1);
      point.update({ dataLabels: { enabled: false } });
    },

    // ======================= 绘制椭圆
    drawEllipse () {
      let xa = this.chart.xAxis[0], ya = this.chart.yAxis[0];
      let points = ['M', xa.toPixels(ellipseData[1][0]), ya.toPixels(ellipseData[1][1]), 'L'];
      ellipseData.slice(2).forEach(p => points.push(xa.toPixels(p[0]), ya.toPixels(p[1])))
      this.chart.renderer.path(points).attr({ id: `${this.chartElId}_trust_ellipse`, stroke: '#000000', 'stroke-width': 1 }).add();
    },
    // ======================= 绘制边框
    drawBorder () {
      let background = this.chart.container.getElementsByClassName('highcharts-plot-background');
      background[0].setAttribute('stroke', '#000000');
    }
  }
}